module.exports = __webpack_public_path__ + "static/media/toc-mockup-font-examples-2.1e55e20c.jpg";